import { Box, Stack, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { textLengthLimit } from '../../NegotiationSupplierIntroductionWidget.util';
import { LanguageAutocomplete } from '~/components/LanguageAutocomplete/LanguageAutocomplete';

import { SupplierIntroductionFormData } from './SupplierIntroductionForm.schema';

export const SupplierIntroductionForm = () => {
  const form = useFormContext<SupplierIntroductionFormData>();
  const { setValue, setError, clearErrors, watch } = form;
  const watchedIntroductionText = watch('text');

  return (
    <Stack spacing={4}>
      <Controller
        name="text"
        render={({ field, fieldState: { error } }) => {
          return (
            <Box sx={{ width: '100%' }}>
              <TextField
                {...field}
                multiline
                rows={14}
                error={!!error}
                value={field.value || ''}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setValue('text', newValue);
                  clearErrors('text');
                  if (newValue.length > textLengthLimit) {
                    setError('text', { type: 'manual' });
                  }
                }}
                fullWidth={true}
                helperText={`${watchedIntroductionText.length} / ${textLengthLimit}`}
              />
            </Box>
          );
        }}
      />
      <Controller
        name="language"
        render={({ field, fieldState: { error } }) => (
          <LanguageAutocomplete
            {...field}
            value={field?.value || null}
            onChange={(_, items) => {
              field.onChange(items);
            }}
            TextFieldProps={{
              error: !!error,
            }}
          />
        )}
      />
    </Stack>
  );
};
